import { createContext, useContext } from "react";

/** True for any subtree rendered inside the app shell. The legacy per-page
 * AppHeader reads this and drops its now-duplicated logo / profile / search
 * (the ribbon owns those), so the ribbon appears everywhere without rewriting
 * every page in one pass. */
export const ShellContext = createContext<{ inShell: boolean }>({ inShell: false });

export const useShell = () => useContext(ShellContext);
